import React, { useCallback, useEffect, useMemo } from 'react'
import styles from './CorrectionRequests.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { laborRecordsSelectors, laborRecordsThunks } from '@/entity'
import { Table } from '@features/laborRecords/frame'
import { Loading } from '@/ui/atoms/loading'

export const CorrectionRequests = () => {
	const dispatch = useDispatch()
	const isLoading = useSelector(laborRecordsSelectors.isAdjustmentLoading)
	const isSuccess = useSelector(laborRecordsSelectors.isAdjustmentSuccess)
	const request = useSelector(laborRecordsSelectors.requestsAdjustment)

	const fetchData = useCallback(() => {
		dispatch(laborRecordsThunks.getRequestsAdjustment())
	}, [dispatch])

	useEffect(() => fetchData(), [fetchData])

	return (
		<div className={styles.wrapper}>
			{!!request?.length ? (
				<Table data={request}></Table>
			) : (
				<Loading isLoading={isLoading} isSuccess={isSuccess} request={request}></Loading>
			)}
		</div>
	)
}
